export class Pagination {
  private readonly skip: number
  private readonly recordsPerPage: number = 10

  constructor(data: { skip: number; recordsPerPage: number }) {
    this.skip = data.skip
    this.recordsPerPage = data.recordsPerPage
  }

  getPageIndex(): number {
    return Number((this.skip + this.recordsPerPage) / this.recordsPerPage)
  }

  getRecordsPerPage(): number {
    return this.recordsPerPage
  }
}
